var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-center"},[(_vm.authHref)?_c('div',[_c('h3',[_vm._v("小提示")]),_c('p',[_vm._v("本活动需要您授权登录后即可进入哦~")]),_c('a',{staticClass:"btn-auth",attrs:{"href":_vm.authHref,"target":"_blank"}},[_vm._v("点击登录")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }